import React from 'react';

const SwapBtn = () => {
  return (
    <span className='material-icons text-white md:text-6xl text-4xl my-3'>
      cached
    </span>
  );
};

export default SwapBtn;
